<template>
  <div class="energy-product-info">
    <div class="detail_content energy">

      <div class="detail_menu">
        <button v-for="tab in tabs" class="clean-button menu_item" :class="{ 'active': activeTab === tab.id }"
          @click="activateTab(tab.id)">
          <Icon :icon="tab.icon" size="sm" />
          <span>{{ tab.label }}</span>
        </button>
      </div>
      <div class="detail_innercontent">

        <Transition :name="slideDirection">
          <component class="product-tab-content" :is="activeTabComponent" v-if="activeTabComponent"
            :key="activateTab.id" :product="product" />
        </Transition>
      </div>
    </div>

  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import ProductPackageTab from '../productInfo/ProductPackageTab.vue';
import ProductGreenTab from '../productInfo/ProductGreenTab.vue';
import ProductProviderTab from '../productInfo/ProductProviderTab.vue';
import ProductPricingTab from '../productInfo/ProductPricingTab.vue';
import Icon from 'vue-elements/icon/Icon.vue';

const props = defineProps({
  product: Object,
  startTab: String,
  showGreen: Boolean,
});

const activeTab = ref('pricing');

const activeTabComponent = computed(() => {
  switch (activeTab.value) {
    case 'pricing':
      return ProductPricingTab;
    case 'package':
      return ProductPackageTab;
    case 'green':
      return ProductGreenTab;
    case 'provider':
      return ProductProviderTab;
  }
});

const tabs = computed(() => {
  return [
    { id: 'pricing', label: 'Tarieven', icon: 'x-fa-euro-sign', size: 'sm' },
    { id: 'package', label: 'Details', icon: 'x-fa-lightbulb' },
    { id: 'green', label: 'Groen', icon: 'x-fa-leaf' },
  ];
});

watch(() => props.startTab, (newTab) => {
  activateTab(newTab);
});

onMounted(() => {
  if (props.startTab) {
    activateTab(props.startTab);
  } else if (props.showGreen) {
    activateTab('provider');
  } else {
    activateTab('pricing');
  }
});
const slideDirection = ref('tab-slide-right');

const activateTab = (tab) => {
  const currentIndex = tabs.value.findIndex(t => t.id === activeTab.value);
  const newIndex = tabs.value.findIndex(t => t.id === tab);
  slideDirection.value = newIndex < currentIndex ? 'tab-slide-left' : 'tab-slide-right';
  activeTab.value = tab;
}

</script>

<style lang="scss">
// TODO: Cleanup this file and add styles to respective Vue files
@use '../../style/_energyProductInfo' as *;

.energy-product-info {
  position: relative;
  overflow: hidden;
}


.tab-slide-right-enter-active,
.tab-slide-left-enter-active,
.tab-slide-right-leave-active,
.tab-slide-left-leave-active {
  transition: transform .35s cubic-bezier(.44, .08, .42, 1.06);
}

.tab-slide-right-leave-active,
.tab-slide-left-leave-active {
  position: absolute;
  width: 100%;
}

.tab-slide-left-leave-to,
.tab-slide-right-enter-from {
  transform: translateX(100%);
}

.tab-slide-left-enter-from {
  transform: translateX(-100%);
}

.tab-slide-right-leave-to {
  transform: translateX(-100%);
}

.tab-slide-left-leave-to {
  transform: translateX(100%);
}
</style>